// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2cl2x","title":"AfterFrontImage_title__1Gq92"};